import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import { SingleSetPromotionModule } from '@gongxigames/framework/promotions';

export class SingleSetPromotionDisableState extends ModuleState<null, SingleSetPromotionModule, GlobalEventsMapForBackwardCompatibility> {
    public onEnterState(): void {}
    public onLeaveState(): void {}
    protected setupEvents(): void {}
}
